import { render } from "./GithubLinks.vue?vue&type=template&id=fcb71044&ts=true"
import script from "./GithubLinks.vue?vue&type=script&lang=ts"
export * from "./GithubLinks.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./GithubLinks.vue?vue&type=style&index=0&id=fcb71044&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__